import ShipmentItem from './ShipmentItem';

export default ShipmentItem;
